import { Row, Col, Card, CardBody, Button, Modal, ModalBody } from "reactstrap";
import { Stream } from "@cloudflare/stream-react";
import { Fragment, useState } from "react";

import { LibraryVideo } from "../../interfaces/models/LibraryVideo";
import { getThumbnailUrl } from "../../helper/getThumbnailUrl";
import Loading from "../Loading";

interface Props {
  videos: LibraryVideo[];
  
}

const LibraryVideoComponent = ({ videos }: Props) => {

  const [loaded, setLoaded] = useState<boolean>(false);
  const [modal, setModal] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState("");
  const toggle = () => setModal(!modal);

  const handleOpen = (video: LibraryVideo) => {
    setSelectedVideo(video.video_id);
    setModal(true)
  }
  return (
    <>
        <Row
        style={{  justifyContent: "center" }}
        className="animated-card"
      >
        {videos.map((video, i) => (
          <Col
            key={"video_" + i}
            xs={12}
            lg={5}
            xl={4}
            className="w-100 my-3"
          >
            <Card
                key={i}
                className="shadow-lg"
              >
                <CardBody className="">
                  <img
                    className="w-100"
                    src={getThumbnailUrl(video.video_id)}
                    alt={video.name}
                  />
                  <div className="text-center">
                  <h5 className="py-3">
                    {video.name}
                  </h5>
                  <div>
                    <Button onClick={() => handleOpen(video)} > <i className="fa fa-play" aria-hidden="true" /> Play</Button>
                  </div>
                  </div>
                </CardBody>
              </Card>
          </Col>
        ))}
      </Row>
      <Modal size="xl" isOpen={modal} toggle={toggle}>
        <ModalBody>
        <Fragment>
          {!loaded && <Loading />}
          <Stream
            className={!loaded && "invisible"}
            onLoadedData={() => setLoaded(true)}
            controls
            autoplay={true}
            src={"video/"+ selectedVideo}
          />
        </Fragment>
        </ModalBody>
      </Modal>
    </>

  );

}

export default LibraryVideoComponent;